/*
 * Copyright (c) 2024 Paul Ostrowski. All rights reserved.
 * Extracted ability-template data (was part of Abilities.ts). Pure data; consumed by Abilities.
*/

export const reactions: Ability[] = [
		{
			name: "Parry",
			desc: "The [MON] adds [PB] to its AC against one melee attack that would hit it. To do so, the [MON] must see the attacker and be wielding a melee weapon.",
			group: "Reactions"
		},
		{
			name: "Split",
			desc: "When a [MON] that is Medium or larger is subjected to lightning or slashing damage, it splits into two new [MONS] if it has at least 10 hit points. Each new [MON] has hit points equal to half the original [MON]'s, rounded down. New [MONS] are one size smaller than the original [MON].",
			group: "Reactions"
		},
		{
			name: "Tail Attack",
			desc: "When a creature the [MON] can see within 10 feet hits the [MON] with a melee attack, the [MON] makes a tail attack against it.",
			group: "Reactions"
		},
	]
